// Marktkuerzel der LUMIERE-Tabelle als Landesname in der Sprache der
// Oberflaeche. Gleiches Muster wie language-options.ts: Intl.DisplayNames,
// pro Locale gecacht, Rueckfall auf das Kuerzel.

const DISPLAY_NAMES_CACHE = new Map<string, Intl.DisplayNames | null>();

/**
 * Kuerzel aufgeloester Staaten, die CLDR auf ihren Nachfolger umbiegt:
 * `Intl.DisplayNames#of("SU")` liefert "Russland". LUMIERE fuehrt RU aber
 * zusaetzlich als eigenen Markt - zwei Zeilen mit demselben Namen waeren nicht
 * auseinanderzuhalten, und die Zuordnung selbst waere falsch. Diese Kuerzel
 * bleiben deshalb stehen.
 *
 * Nachgewiesen im Bestand ist bisher nur SU (ohne Zuschauerzahlen, taucht also
 * noch in keiner Liste auf). Die uebrigen drei sind dieselbe Fehlerklasse und
 * stehen vorsorglich mit drin, damit ein Nachlauf der Quelle sie nicht
 * unbemerkt falsch benennt.
 */
const HISTORIC_MARKETS = new Set(["SU", "YU", "CS", "DD"]);

function regionNames(locale: string): Intl.DisplayNames | null {
  if (DISPLAY_NAMES_CACHE.has(locale)) return DISPLAY_NAMES_CACHE.get(locale) ?? null;
  let dn: Intl.DisplayNames | null = null;
  try {
    dn = new Intl.DisplayNames([locale], { type: "region" });
  } catch {
    // Intl.DisplayNames nicht verfuegbar - dann bleiben die Kuerzel stehen.
  }
  DISPLAY_NAMES_CACHE.set(locale, dn);
  return dn;
}

/**
 * Landesname zu einem Marktkuerzel, z.B. "DE" zu "Deutschland".
 *
 * "GB_IE" ist LUMIEREs kombinierter Markt (Vereinigtes Koenigreich + Irland)
 * und kein ISO-Code: `Intl.DisplayNames#of` wirft darauf einen RangeError.
 * Deshalb wird an "_" geteilt und aus beiden Namen zusammengesetzt.
 */
export function marketLabel(market: string, locale: string): string {
  const dn = regionNames(locale);
  return market
    .split("_")
    .map((code) => {
      if (!dn || HISTORIC_MARKETS.has(code)) return code;
      try {
        return dn.of(code) ?? code;
      } catch {
        return code;
      }
    })
    .join(" & ");
}
